import { Flex } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

import { Condition } from 'Component/others';
import ButtonOutline from 'UiKit/button/buttonOutline';
import { EditIcon, TrashIcon } from 'Asset/icon';
import { getMenuPermissions } from 'Helper/getMenuPermissions';

import useOpenDeleteModal from 'View/role/hooks/useOpenDeleteModal';

const ActionButton = ({ value }) => {
  const accessPermission = getMenuPermissions('master-data', 'access');
  const navigate = useNavigate();

  const { onOpenDeleteModal } = useOpenDeleteModal();

  return (
    <Flex gap="10px">
      <Condition statement={accessPermission?.isCanEdit}>
        <ButtonOutline
          borderWidth="1.5px"
          data-testid="action-button__edit-button"
          width="34px"
          height="34px"
          onClick={() => {
            navigate(`/master-data/access/upsert/${value}`);
          }}
        >
          <EditIcon color="var(--color-semantic-text)" />
        </ButtonOutline>
      </Condition>

      <Condition statement={accessPermission?.isCanDelete}>
        <ButtonOutline
          borderWidth="1.5px"
          color="var(--color-error50)"
          data-testid="action-button__delete-button"
          width="34px"
          height="34px"
          onClick={() => {
            onOpenDeleteModal(value);
          }}
        >
          <TrashIcon color="var(--color-error50)" />
        </ButtonOutline>
      </Condition>
    </Flex>
  );
};

export default ActionButton;
